/* eslint-disable no-nested-ternary */
import {
  Box,
  ShipmentHook,
  SpinnerMedium,
  Truck,
} from '@tmov/design-system/icons';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { LoadingContainer } from '../../../../components/LoadingContainer';
import { formatarMilhar } from '../../../../helpers/formatador';
import useCardData from '../hooks/useCardData';
import useMedidaProdutoData from '../hooks/useMedidaProdutoData';
import ProdutoBarChart from './ProdutoBarChart';
import {
  Container,
  IconContainer,
  MedidaHeader,
  StatsCard,
  StatsTextContainer,
} from './styles';

const Stats = ({ clientes, filters }) => {
  const { cardData, loadingCardData } = useCardData({ filters, clientes });
  const { medidaProdutoData, loadingMedidaProdutoData } = useMedidaProdutoData({
    filters,
    clientes,
  });

  const topMedidaProdutoData = useMemo(() => {
    if (!medidaProdutoData || !filters.medida?.value) {
      return [];
    }
    const dataOrderedBySize = medidaProdutoData.sort(
      (a, b) => a[filters.medida.value] > b[filters.medida.value]
    );
    return dataOrderedBySize.slice(0, 5);
  }, [filters?.medida?.value, medidaProdutoData]);

  const stats = [
    {
      icon: <Box />,
      label: 'Volume',
      value:
        typeof cardData?.volumeTotal === 'number'
          ? formatarMilhar(cardData.volumeTotal)
          : 'N.A.',
    },
    {
      icon: <Truck />,
      label: 'Viagens',
      value:
        typeof cardData?.quantidadeViagens === 'number'
          ? cardData.quantidadeViagens
          : 'N.A.',
    },
    {
      icon: <ShipmentHook />,
      label: 'Demandas',
      value:
        typeof cardData?.numDemandas === 'number'
          ? cardData.numDemandas
          : 'N.A.',
    },
  ];

  return (
    <Container>
      {stats.map(stat => (
        <StatsCard key={stat.label}>
          {!loadingCardData ? (
            <>
              <IconContainer>{stat.icon}</IconContainer>
              <StatsTextContainer>
                <p>{stat.label}</p>
                <h3>{stat.value}</h3>
              </StatsTextContainer>
            </>
          ) : (
            <LoadingContainer>
              <SpinnerMedium />
            </LoadingContainer>
          )}
        </StatsCard>
      ))}
      <StatsCard>
        {topMedidaProdutoData?.length > 0 ? (
          <>
            <MedidaHeader>{filters.medida?.value} por produto</MedidaHeader>
            <ProdutoBarChart
              data={topMedidaProdutoData}
              xKey="nome_subproduto"
              yKey={filters.medida?.id}
            />
          </>
        ) : loadingMedidaProdutoData ? (
          <LoadingContainer>
            <SpinnerMedium />
          </LoadingContainer>
        ) : (
          <h3>Não há dados de produto para os filtros definidos</h3>
        )}
      </StatsCard>
    </Container>
  );
};

Stats.propTypes = {
  clientes: PropTypes.arrayOf(PropTypes.string).isRequired,
  filters: PropTypes.shape({
    periodo: PropTypes.arrayOf(PropTypes.object),
    handlePeriodo: PropTypes.func,
    produto: PropTypes.shape({
      id: PropTypes.number,
      value: PropTypes.string,
    }),
    handleProduto: PropTypes.func,
    cidade: PropTypes.shape({
      id: PropTypes.number,
      value: PropTypes.string,
    }),
    handleCidade: PropTypes.func,
    estado: PropTypes.shape({
      id: PropTypes.number,
      value: PropTypes.string,
    }),
    handleEstado: PropTypes.func,
    medida: PropTypes.shape({
      id: PropTypes.string,
      value: PropTypes.string,
    }),
    handleMedida: PropTypes.func,
  }).isRequired,
};

export default Stats;
